module.exports = __webpack_public_path__ + "img/internet.afb816ac.svg";